
import React, { Component } from 'react';
import { translate } from "react-i18next";
import { sendJson, getURL } from '../../backend/Backend';
import { Tooltip, OverlayTrigger, Row, Col, Card, Pagination } from 'react-bootstrap';
import { EVENT_IMG_URL } from '../../backend/Backend';
import { Link } from 'react-router-dom';
import { getDateDisplayValue, isEditable } from '../../backend/UIUtils';
import AdminSearch from './AdminSearch';
import NotifyView from './NotifyView';


class AdminPrivateEventList extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.searchEvents = this.searchEvents.bind(this);

        this.state = {
            events: [],
            activePage: 1,
            totalPages: 0,
            criteria: null
        }
    }


    async searchEvents(criteria, page) {

        if (!page) {
            return;
        }
        if ("<" === page) {
            page = --this.state.activePage;
        }
        if (">" === page) {
            page = ++this.state.activePage;
        }

        console.log("criteria2:" + JSON.stringify(criteria));
        let converted = 'category=' + (criteria.eventCategory ? criteria.eventCategory : '');
        converted += "&";
        converted += 'sub=' + (criteria.subCategory ? criteria.subCategory : '');
        converted += "&";
        converted += 'city=' + (criteria.city ? criteria.city : '');
        converted += "&";
        converted += 'startDate=' + (criteria.startDate ? criteria.startDate : '');
        converted += "&";
        converted += 'endDate=' + (criteria.endDate ? criteria.endDate : '');
        converted += "&";
        converted += 'notified=' + (criteria.notified ? criteria.notified : 'false');
        converted += "&";
        converted += 'eventType=' + this.props.eventType;
        converted += "&";
        converted += 'page=' + (page);


        console.log("converted:" + converted);
        const response = await fetch(getURL(`a-events/eventSearch?${converted}`));
        const json = await response.json();
        //console.log("json search result:" +JSON.stringify(json));

        let oldState = this.state;
        this.setState({
            ...oldState,
            events: json.content,
            totalPages: json.totalPages,
            activePage: page,
            criteria: criteria
        });
    }



    async pageChanged(e) {
        this.searchEvents(this.state.criteria, e.target.text);
    }


    handleChange(oldParameter) {

        let parameters = this.state.parameters;
        let p = parameters.find(p => p.key === oldParameter.key);
        let pIndex = parameters.findIndex(p => p.key === oldParameter.key);


        p.value = oldParameter.value === '1' ? '0' : '1';



        let newParameters = [...parameters.slice(0, pIndex),
            p,
        ...parameters.slice(pIndex + 1)];

        this.setState({
            parameters: newParameters
        });
    }


    updateAll() {
        sendJson('put', 'parameters/updateAll', this.state.parameters).then(
            received => {
                //this.props.onAdd(received); 
                if (received.ok) {
                    console.log("parameters saved  :-)");
                    let oldState = this.state;
                    this.setState({
                        ...oldState,
                        message: received.message
                    });
                    setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
                }
            });
    }

    toUrl(e) {
        let sep = '-';
        let url = e.token + sep;//+ e.eventId ;
        if (e.id) {
            url += e.id;
        }
        if (e.eventId) {
            url += e.eventId;
        }

        return url;
    }



    render() {
        const { t } = this.props;
        let sep = '-';
        var options = { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit', hour: 'numeric', minute: 'numeric' };
        if (!this.state.events) {
            return "NO"
        }

        return (
            <div>
                <AdminSearch searchEvents={this.searchEvents} searchType={this.props.eventType} />
                <Row className="justify-content-md-center" >
                    {this.state.events.map((e, i) =>
                        <Col lg={6} md={12} xs={12} className=" mb-2  " key={i}>
                            <Card style={{ height: "100%" }}>
                                <Card.Img variant="top" src={e.imageName ? EVENT_IMG_URL + e.imageName : "/img/produkt-premium-3.jpg"} height={"200px"} />
                                <Card.Body  >
                                    <Card.Title  >

                                        <h4 className="card-title text-success "><i className={(e.eventType === 'ACTIVITY' ? " fas fa-globe-europe " : " fas fa-lock ") + " s16  mr-1"} ></i>
                                            <Link to={`/eventEdit/${this.toUrl(e) + sep + e.creationUserId}`} className=" text-dark"  >{e.title}</Link>
                                        </h4>
                                    </Card.Title>
                                    <Card.Subtitle className="mb-2 text-muted">
                                        <Row>
                                            <Col><i className="text-success fa fa-user s16  mr-1" ></i>{e.creationUserName}</Col>
                                        </Row>
                                        <Row>
                                            <Col><i className="text-success fa fa-clock s16  mr-1" ></i>{getDateDisplayValue(e.startDate, options)}</Col>
                                        </Row>

                                    </Card.Subtitle>
                                    <Card.Text>
                                        {e.description}
                                    </Card.Text>
                                    {e.notifyId ?
                                       <NotifyView entity={e} />
                                       :
                                       ''

                                    }
                                </Card.Body>
                                {isEditable(e.creationUserId) ?
                                    <Card.Footer>
                                        <OverlayTrigger
                                            key="top"
                                            placement="top"
                                            overlay={
                                                <Tooltip id={`tooltip-top`}>
                                                    {t("bearbeiten")}
                                                </Tooltip>
                                            }>
                                            <Link to={`/eventChange/${this.toUrl(e) + sep + e.creationUserId}`} className={' outline-primary float-right mr-1 '}>
                                                <span className="text-primary fa fa-edit  mr-1"></span>{t("edit")}</Link>
                                        </OverlayTrigger>
                                    </Card.Footer>

                                    :
                                    ''
                                }
                            </Card>
                        </Col>


                    )}
                </Row>
                <Pagination onClick={this.pageChanged}>
                    {this.state.activePage > 1 ?
                        <Pagination.Item>{'<'}</Pagination.Item>
                        : ""
                    }

                    {[...Array(this.state.totalPages).keys()].map(i => {
                        return <Pagination.Item active={(i + 1) === this.state.activePage} key={i}>{i + 1}</Pagination.Item>
                    })
                    }
                    {this.state.activePage < this.state.totalPages ?
                        <Pagination.Item>{'>'}</Pagination.Item>
                        : ""
                    }

                </Pagination>
            </div>)

    }


}

export default translate("translations")(AdminPrivateEventList);